import { useEffect, useState } from "react";
import { HeartHandshake, Phone, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useEdition } from "@/lib/edition";

export const WellbeingDialog = () => {
  const [msg, setMsg] = useState("");
  const { corp } = useEdition();
  useEffect(() => {
    const on = (e) => setMsg(e.detail || "You're not alone. Please talk to someone you trust.");
    window.addEventListener("daybreyk:wellbeing", on);
    return () => window.removeEventListener("daybreyk:wellbeing", on);
  }, []);
  return (
    <Dialog open={Boolean(msg)} onOpenChange={(o) => { if (!o) setMsg(""); }}>
      <DialogContent data-testid="wellbeing-dialog" className="max-w-md rounded-3xl bg-white">
        <DialogHeader>
          <div className="mx-auto mb-2 grid h-12 w-12 place-items-center rounded-full bg-gold-400/20"><HeartHandshake className="h-6 w-6 text-gold-300" /></div>
          <DialogTitle className="text-center font-display text-2xl text-slate-900">You matter</DialogTitle>
          <DialogDescription data-testid="wellbeing-message" className="text-center text-sm leading-relaxed text-slate-700">{msg}</DialogDescription>
        </DialogHeader>
        <div className="mt-2 grid gap-2">
          {corp ? (
            <>
              <a data-testid="wellbeing-call-samaritans" href="tel:116123" className="flex items-center justify-center gap-2 rounded-full bg-navy-900 px-4 py-3 text-sm font-semibold text-white"><Phone className="h-4 w-4" />Call Samaritans · 116 123</a>
              <a data-testid="wellbeing-call-nhs" href="tel:111" className="flex items-center justify-center gap-2 rounded-full border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-800"><Phone className="h-4 w-4" />NHS 111 (mental health option)</a>
            </>
          ) : (
            <>
              <a data-testid="wellbeing-call-childline" href="tel:08001111" className="flex items-center justify-center gap-2 rounded-full bg-navy-900 px-4 py-3 text-sm font-semibold text-white"><Phone className="h-4 w-4" />Call Childline · 0800 1111</a>
              <a data-testid="wellbeing-chat-childline" href="https://www.childline.org.uk/get-support/1-2-1-counsellor-chat/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 rounded-full border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-800"><MessageCircle className="h-4 w-4" />Chat online with Childline</a>
            </>
          )}
          <a data-testid="wellbeing-text-shout" href="sms:85258?body=SHOUT" className="flex items-center justify-center gap-2 rounded-full border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-800">Text SHOUT to 85258</a>
          <button data-testid="wellbeing-close" onClick={() => setMsg("")} className="mt-1 text-sm text-slate-600 underline">Close</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
